import { createContext, useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { getUserById, loginUser } from "../api/user.service";
import { notification } from "antd";

export const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const history = useHistory();

    const fetchUser = async ()=>{
        const user = JSON.parse(localStorage.getItem("user")) || null
        if (user) {
            try {
                let data = await getUserById(user.id)
                setUser(data?.data || null)
            } catch (error) {
                localStorage.removeItem("token");
                localStorage.removeItem("user");
                setUser(null);
            }
        }
    }

    useEffect(() => {
        fetchUser()
    }, []);

    const login = async (credentials) => {
        try {
            const  data  = await loginUser(credentials)
            localStorage.setItem("token", data.access_token);
            setUser(data.data);
            localStorage.setItem("user", JSON.stringify(data.data))
            history.push("/overview");
        } catch (error) {
            console.log('eroror', error);
            notification.error({
                message: error?.response?.data?.message || 'Login failed'
            })
            console.error("Login failed", error);
        }
    };

    const logout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        setUser(null);
        history.push("/sign-in");
    };

    return (
        <AuthContext.Provider value={{ user, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};
